<br>
<br>
<header class="header">
  <div class="nubes"></div>
  <div style="position:relative;" class="container">
    <div class="row">
      <div class="col-xs">
        <div class="logo"><img src="./assets/img/ico-hoja.svg" alt="Hojas"></div>
        <h1>Siempre prefiere <span>tu Boleta Electrónica</span></h1><a href="#" class="callToHeader">Cámbiate aquí</a>
      </div>
    </div>
  </div>
</header>
<div class="arrow"><img src="./assets/img/arrow.svg" alt="Conoce tu boleta"></div>
<div class="main">
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <div class="video-vimeo">
          <div class="video-responsive">
            <iframe src="https://player.vimeo.com/video/409857458" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            <!--<iframe src="https://player.vimeo.com/video/409857458" width="640" height="379" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <h2>Porque queremos que nuestros clientes estén informados,<br class="brake"> te presentamos los aspectos más importantes de tu boleta de gas natural. </h2>
      </div>
      <div class="col-xs-12">
        <div class="boletas">
          <div class="boletas__img"><img src="./assets/img/boleta_01.jpg" alt="Boleta">
            <div class="sonar__box__move">
              <div class="sonar-marker_move">
                <div id="showPanel" class="sonar-marker"></div>
              </div>
              <div id="panel" class="sonar__box--info">
                <div id="hidePanel" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">Número de cliente</div>
                <div class="sonar__box--info--text">Es tu identificador y con él puedes acceder a los datos de tu suministro desde el sitio web o llamando al centro de ayuda. Te recomendamos tenerlo siempre a mano.</div>
              </div>
            </div>
            <div class="sonar__box__move">
              <div class="sonar-marker_move2">
                <div id="showPanel2" class="sonar-marker"></div>
              </div>
              <div id="panel2" class="sonar__box--info">
                <div id="hidePanel2" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">Total a pagar</div>
                <div class="sonar__box--info--text">En este espacio se indica el monto adeudado, detallando también el período al que corresponde el consumo y si tienes saldo anterior pendiente de pago.</div>
              </div>
            </div>
            <div class="sonar__box__move">
              <div class="sonar-marker_move3">
                <div id="showPanel3" class="sonar-marker"></div>
              </div>
              <div id="panel3" class="sonar__box--info">
                <div id="hidePanel3" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">Fecha de vencimiento</div>
                <div class="sonar__box--info--text">Es el plazo límite para el pago de la cuenta, y no pagar antes de esa fecha dará lugar a cobro de intereses o bien a la suspensión del servicio. </div>
              </div>
            </div>
          </div>
        </div>
        <div class="boletas">
          <div class="boletas__img"><img src="./assets/img/boleta_02.jpg" alt="Boleta">
            <div class="sonar__box__move">
              <div class="sonar-marker_move4">
                <div id="showPanel4" class="sonar-marker"></div>
              </div>
              <div id="panel4" class="sonar__box--info">
                <div id="hidePanel4" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">Detalle de mi cuenta</div>
                <div class="sonar__box--info--text">En este espacio se detallan todos los cargos que se aplican en la boleta, apareciendo el consumo de gas, cuotas de artefactos o tu consumo mensual de Metrobolsa.<br><br>Recuerda que Metrogas no realiza cobros por arriendo de medidor, por lo que siempre aparecerá en cero.<br><br>Si eres socio del Club Metrogas,¡aquí puedes conocer tus Metropuntos acumulados!</div>
              </div>
            </div>
            <div class="sonar__box__move">
              <div class="sonar-marker_move5">
                <div id="showPanel5" class="sonar-marker"></div>
              </div>
              <div id="panel5" class="sonar__box--info">
                <div id="hidePanel5" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">Conceptos importantes<br>de tu boleta</div>
                <div class="sonar__box--info--text">Queremos que siempre estés informado de tu boleta.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="boletas">
          <div class="boletas__img"><img src="./assets/img/boleta_03.jpg" alt="Boleta">
            <div class="sonar__box__move">
              <div class="sonar-marker_move6">
                <div id="showPanel6" class="sonar-marker"></div>
              </div>
              <div id="panel6" class="sonar__box--info">
                <div id="hidePanel6" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">Mi consumo en el<br> mes actual</div>
                <div class="sonar__box--info--text">Se detalla cómo se calculó tu consumo del período indicado, el que corresponde a la diferencia entre la lectura anterior (de la facturación anterior) y la actual.
                  <div class="otrotext">
                    <p>A este resultado, que sería tu consumo del periodo facturado en la última boleta, se le aplica el denominado <span>factor de estandarización</span>, valor numérico que se aplica al consumo en metros cúbicos registrados por el medidor, determinados por la diferencia entre la lectura actual y anterior, para conocer cuál fue el real consumo de gas. De esta forma, en el cálculo se toman en cuenta factores como la temperatura, la presión y el poder calorífico del gas.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="sonar__box__move">
              <div class="sonar-marker_move7">
                <div id="showPanel7" class="sonar-marker"></div>
              </div>
              <div id="panel7" class="sonar__box--info">
                <div id="hidePanel7" class="cerrar"><img src="./assets/img/cerrar.png" alt="Cerrar"></div>
                <div class="sonar__box--info--titulo">¿Cuál fue mi consumo<br> de los últimos 13 meses?</div>
                <div class="sonar__box--info--text">En este gráfico se muestra el historial de consumo en metros cúbicos de los últimos meses, indicando también un cuadro comparativo con el del mes anterior y el mismo mes del año pasado, con lo que podrás revisar si aumentaste o disminuiste tu consumo.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="prefinal">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <h3>¿Dudas con tu cuenta?</h3>
              <p>Te recomendamos siempre revisar la boleta anterior y tu historial de consumo, a los que puedes tener acceso fácilmente desde Mi Cuenta Online.</p>
              <!--<p>Si aún no te registras, hazlo aquí: </p><a href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida" target="_blank" class="registra">Regístrate Aquí</a>-->
              <p>Si aún no te registras, hazlo aquí: </p><a href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida" target="_blank" class="registra">Regístrate Aquí</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <div class="footer-box">
          <div class="logoFooter"><img src="./assets/img/logo-bottom.svg" alt="Ecológico"></div>
          <div class="logoFooter-text">
            <p><span class="bgp">Recuerda que somos metroambientalistas,</span> deja de imprimir esta boleta suscribiéndote a su envío electrónico</p>
            <p>Confirma tu suscripción
            <a href="https://www.centrodeayudametrogas.cl/suscripcion-boleta-electronica" target="_blank" class="aqui">aquí</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
